import React from 'react';
import './pasos.css';
import Cuadro from './Cuadro';
import Linea from './Linea';
import {ErrorPerdida} from 'errores';

class Pasos extends React.Component {

    render() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarVistaVisitadaAnalitica("Pasos");    
        }
        let arreglo = Array.from(this.props.pasos.otrosEstatus);
        arreglo.push(this.props.pasos.estatusActual);
        arreglo.sort(function(a, b) {
            return a.orden - b.orden;
        });
        if(arreglo.filter(t => t.actividad==="Venta de contado").length){
            arreglo = arreglo.filter(t => t.nombreEstatus!== "Solicitud de crédito" && t.nombreEstatus!=="Autorización de crédito" && t.nombreEstatus!=="Pago de enganche");
        }
        return(
            <div className="container">
                <div className="col col-md-8 offset-md-2 mt-3">
                    <p className={"small font-weight-bold"+(this.props.offline?" d-block":" d-none")+(this.props.marca==="seat"?" pasos__guia--seat":"")}>{this.props.pasos.estatusActual.idCompra}</p>
                    <p className={(this.props.marca==="seat"?("sincompras__label pasos__titulo--"+this.props.marca):"h5 pt-2 pb-2")}><span className={"pasos__titulo--"+this.props.marca}>Tu proceso</span> al día de hoy:</p>
                    <p className={(this.props.marca==="seat"?("h4 pasos__modelo--"+this.props.marca):"h5 font-weigth-bold")}>{this.props.modelo===undefined?"":this.props.modelo}</p>
                </div>
                <div className="col">
                    <div className={"col col-md-8 offset-md-2 pt-3 pb-3 mb-3 pasos__container pasos__container--"+this.props.marca+(this.props.pasos.estatusActual.resultado==="Perdida"?" error":"")+(this.props.marca==="audi"?" mt-3":this.props.marca==="vw"?" mt-5":"")}>
                        <h5 className={"pasos__titulo--"+this.props.marca+(this.props.pasos.estatusActual.resultado==="Perdida"?" error":"")}>{this.props.pasos.estatusActual.nombreEstatus}</h5>
                        <div className="row mt-2 mb-3">
                            <div className="col">
                                {
                                    arreglo.map((paso,i, arr) => {
                                        return <Cuadro paso={paso} pasoActual={this.props.pasos.estatusActual} marca={this.props.marca} key={"c_"+paso.nombreEstatus+""+paso.idHistorialEstatus} ultimo={arr.length-1===i}/>;
                                    })
                                }
                            </div>
                        </div>
                        <div className="mt-3">
                            <p className="medium mb-0">Historial de seguimiento.</p>
                            <div className={"col pasos__historial--"+this.props.marca}>
                                {
                                    arreglo.map((paso,i) => {
                                        return <Linea paso={paso} key={"l_"+paso.nombreEstatus+paso.idHistorialEstatus} pasoActual={this.props.pasos.estatusActual}/>;
                                    })
                                }
                            </div>
                        </div>
                        {
                            this.props.pasos.estatusActual.resultado==="Perdida"?<ErrorPerdida marca={this.props.marca} />:""
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Pasos;